import { getSiteOrigin } from './constants';

export const SITE_NAME = 'ARKDetali';
export const DEFAULT_TITLE = 'ARKDetali — Автозапчастини';
export const DEFAULT_DESCRIPTION = 'Широкий вибір гальмівних трубок та автокомпонентів.';
const DEFAULT_OG_IMAGE = '/static/media/og-preview.jpg';

export const formatPageTitle = (pageTitle) => {
  if (!pageTitle) return DEFAULT_TITLE;
  const trimmed = String(pageTitle).trim();
  if (trimmed.includes(SITE_NAME)) return trimmed;
  return `${trimmed} | ${SITE_NAME}`;
};

const setMetaName = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const removeMetaName = (name) => {
  document.querySelector(`meta[name="${name}"]`)?.remove();
};

const setMetaProperty = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const removeMetaProperty = (property) => {
  document.querySelector(`meta[property="${property}"]`)?.remove();
};

const setCanonical = (href) => {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const removeCanonical = () => {
  document.querySelector('link[rel="canonical"]')?.remove();
};

const setLinkRel = (rel, href) => {
  if (!href) {
    document.querySelector(`link[rel="${rel}"]`)?.remove();
    return;
  }
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const setPaginationLinks = ({ prev, next }) => {
  setLinkRel('prev', prev ? absoluteUrl(prev) : null);
  setLinkRel('next', next ? absoluteUrl(next) : null);
};

export const absoluteUrl = (path) => {
  if (!path) return getSiteOrigin() || '';
  if (path.startsWith('http')) return path;
  const origin = getSiteOrigin();
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};

const applySocialMeta = (title, description, ogImage) => {
  setMetaProperty('og:title', title);
  setMetaProperty('og:description', description);
  setMetaProperty('og:locale', 'uk_UA');
  setMetaProperty('og:site_name', SITE_NAME);
  setMetaName('twitter:title', title);
  setMetaName('twitter:description', description);

  if (ogImage) {
    const imageUrl = absoluteUrl(ogImage);
    setMetaProperty('og:image', imageUrl);
    setMetaName('twitter:card', 'summary_large_image');
    setMetaName('twitter:image', imageUrl);
  }
};

const applyProductMeta = ({ price, inStock }) => {
  if (price != null) {
    setMetaProperty('product:price:amount', String(price));
    setMetaProperty('product:price:currency', 'UAH');
  } else {
    removeMetaProperty('product:price:amount');
    removeMetaProperty('product:price:currency');
  }

  if (inStock != null) {
    setMetaProperty('og:availability', inStock ? 'instock' : 'out of stock');
  } else {
    removeMetaProperty('og:availability');
  }
};

export const applyHomeSeo = () => {
  document.title = DEFAULT_TITLE;
  setMetaName('description', DEFAULT_DESCRIPTION);
  setMetaName('robots', 'index, follow');
  setCanonical(absoluteUrl('/'));
  setMetaProperty('og:type', 'website');
  setMetaProperty('og:url', absoluteUrl('/'));
  applySocialMeta(DEFAULT_TITLE, DEFAULT_DESCRIPTION, DEFAULT_OG_IMAGE);
  applyProductMeta({});
  setPaginationLinks({});
};

export const applyNoIndexSeo = (title = DEFAULT_TITLE) => {
  document.title = formatPageTitle(title);
  setMetaName('robots', 'noindex, nofollow');
  removeMetaName('description');
  removeCanonical();
  setPaginationLinks({});
};

export const applyPageSeo = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  ogType = 'website',
  robots = 'index, follow',
  price,
  inStock,
  pagination,
}) => {
  const formattedTitle = formatPageTitle(title);

  if (title) {
    document.title = formattedTitle;
  }

  if (description) {
    setMetaName('description', description);
  } else {
    removeMetaName('description');
  }

  if (keywords) {
    setMetaName('keywords', keywords);
  } else {
    removeMetaName('keywords');
  }

  setMetaName('robots', robots);

  if (canonical) {
    setCanonical(absoluteUrl(canonical));
  } else {
    removeCanonical();
  }

  setMetaProperty('og:type', ogType);
  setMetaProperty('og:url', canonical ? absoluteUrl(canonical) : absoluteUrl('/'));
  applySocialMeta(formattedTitle, description || DEFAULT_DESCRIPTION, ogImage);
  applyProductMeta({ price, inStock });

  if (pagination) {
    setPaginationLinks(pagination);
  } else {
    setPaginationLinks({});
  }
};

export const resetPageSeo = () => {
  applyHomeSeo();
};
